import { AltArrowExpand } from "@airhelp/icons";
import { Select } from "@chakra-ui/react";
import { useTranslations } from "contexts/LocalizationContext";
import { useState } from "react";
import options from "./config";
import type { OptionValue, SelectDateProps } from "./types";
import { getBySeason } from "./utility";

const SelectDate = ({ updateTableContent, scoresType }: SelectDateProps) => {
  const [defaultOption] = options[scoresType];
  const [activeOption, setActiveOption] = useState<OptionValue>(defaultOption.value);
  const translations = useTranslations();

  const handleOnChange = async ({ target: { value } }) => {
    setActiveOption(value as OptionValue);
    const content = await getBySeason(value, scoresType);
    updateTableContent(content);
  };

  return (
    <Select
      h="48px"
      bg="white"
      w={{ base: "full", lg: 60 }}
      icon={<AltArrowExpand />}
      onChange={handleOnChange}
      border="1px"
      borderColor="greyscale.400"
      defaultValue={activeOption}
    >
      {options[scoresType].map(({ value, label: { season, year } }) => (
        <option key={value} value={value}>
          {season && translations(season)}&nbsp;{year}
        </option>
      ))}
    </Select>
  );
};

export default SelectDate;
